<table>
	<thead>
		<tr>
			@if (checkboxEnabled) {
				<th class="checkbox"></th>
			}
			<th>Instelling</th>
			<th>Labels</th>
			@if (statusEnabled) {
				<th>Status</th>
			}
			@if (etlStatusEnabled) {
				<th>Volgende ETL bulk</th>
				<th>Laatste delta</th>
				<th>Laatste bulk</th>
			}
			@for (licentieRol of licenties; track licentieRol) {
				@if ($first && $last && licentieRol === LicentieRol.BESTUUR) {
					<th>Licenties in gebruik</th>
				} @else {
					<th>{{ getLicentieRolLabel(licentieRol) }}</th>
				}
			}
		</tr>
	</thead>
	<tbody>
		@for (instelling of instellingen; track instelling.id) {
			@if (getStatus(instelling); as status) {
				<tr [class.inactief]="!instelling.actief || status.disabled" (click)="click($event, instelling)">
					@if (checkboxEnabled) {
						<td class="checkbox">
							<app-checkbox [enabled]="!status.disabled" [value]="status.checked"> </app-checkbox>
						</td>
					}
					<td
						[class.status]="status.instellingETLStatus && etlIconStatussen.includes(status.instellingETLStatus)"
						[appTooltip]="instelling.additionalObjects?.[RInstellingAdditionalObjectKey.VESTIGING_NAMEN]?.namen?.join(', ')"
						[tooltipPosition]="'right'"
					>
						<div class="naam">
							<span>
								{{ instelling.naam }}
							</span>
							@if (status.instellingETLStatus && ETL_STATUS_ICON[status.instellingETLStatus]; as icon) {
								<app-icon [name]="icon.name" [color]="icon.color" [title]="icon.title"></app-icon>
							}
							@if (status.outdatedBackup) {
								<app-icon name="warning" color="warning-1" title="De laatste backup van deze instelling is verouderd"></app-icon>
							}
						</div>
					</td>
					<td>
						<app-instelling-labels [instelling]="instelling" [toonBestuur]="toonBestuurLabel"></app-instelling-labels>
					</td>
					@if (statusEnabled) {
						<td>
							<span>
								{{ instelling.actief ? "Actief" : "Gedeactiveerd" }}
							</span>
						</td>
					}
					@if (etlStatusEnabled) {
						<td>
							<span>
								{{ instelling.nextETLBulk ? "Gepland" : "Niet gepland" }}
							</span>
						</td>
						<td>
							<div class="etl-status">
								<div class="label" [ngClass]="status.laatsteDelta?.instellingETLStatus?.toLowerCase()">
									{{ status.laatsteDelta?.instellingETLStatus }}
								</div>
								<span>
									{{ status.laatsteDelta?.vanaf | date: "d-M-yyyy 'om' H:mm" }}
								</span>
							</div>
						</td>
						<td>
							<div class="etl-status">
								<div class="label" [ngClass]="status.laatsteBulk?.instellingETLStatus?.toLowerCase()">
									{{ status.laatsteBulk?.instellingETLStatus }}
								</div>
								<span>
									{{ status.laatsteBulk?.vanaf | date: "d-M-yyyy 'om' H:mm" }}
								</span>
							</div>
						</td>
					}
					@for (licentieRol of licenties; track licentieRol) {
						<td>
							<span>
								{{ getLicenties(instelling, licentieRol) }}
							</span>
						</td>
					}
				</tr>
			}
		}
	</tbody>
	<tfoot>
		@if (totaalEnabled) {
			<tr>
				@if (checkboxEnabled) {
					<td></td>
				}
				<td [class.after-checkbox]="checkboxEnabled">Totaal</td>
				<td></td>
				@if (statusEnabled) {
					<td></td>
				}
				@if (etlStatusEnabled) {
					<td></td>
					<td></td>
					<td></td>
				}
				@for (licentieRol of licenties; track licentieRol) {
					<td>{{ getTotaalLicenties(licentieRol) }}</td>
				}
			</tr>
		}
	</tfoot>
</table>
